/*
	Image Archive URLs
	These apis are meant for working with the Columbia_Info zip files.
*/

import { readPrerenderedData } from "@fluke/is2u-prerendered-data";

export async function _unpackImageArchive(blob, name) {
  try {
    if (blob) {
      const preRenderedData = await readPrerenderedData(blob);
      const preview = URL.createObjectURL(preRenderedData.previewImage);
      const visual = URL.createObjectURL(preRenderedData.vlImage);
      const photonotes = preRenderedData.photonotes.map((photo) => {
        return {
          src: URL.createObjectURL(photo.src),
          name,
        };
      });
      return {
        name,
        imageJSON: preRenderedData.prerenderedInfo,
        preview,
        visual,
        photonotes,
      };
    }
  } catch (error) {
    console.error(error);
  }
}

async function _fetchImageArchive(url) {
    const response = await fetch(url);
  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return await response.blob();
}

async function _fetchImageArchiveByUrl(pURL, name) {
  let imageData = {};
  if (pURL == null) return imageData;

  const data = await _fetchImageArchive(pURL);
  imageData = await _unpackImageArchive(data, name);

  // get the image id
  const {
    imageJSON: {
      main: { image_id },
    },
  } = imageData;

  // append extra data
  imageData.url = pURL;
  imageData.imageId = image_id;

  return imageData;
}

export const imageArchive = {
  fetchImageArchiveByUrl:_fetchImageArchiveByUrl,
  unpackImageArchive:_unpackImageArchive,
  fetchImageArchive:_fetchImageArchive
};

